export const DEFAULT_BROWSER_IGNORE_ERRORS = [
    'ResizeObserver loop limit exceeded',
    'ResizeObserver loop completed with undelivered notifications',
    'Non-Error promise rejection captured',
    /^Loading chunk [\d]+ failed/,
    'ChunkLoadError',
    'Network Error',
    'AbortError',
    'The operation was aborted',
    'cancelled',
];
export const DEFAULT_BROWSER_DENY_URLS = [
    /extensions\//i,
    /^chrome:\/\//i,
    /^chrome-extension:\/\//i,
    /^moz-extension:\/\//i,
    /^safari-extension:\/\//i,
];
export const DEFAULT_NODE_IGNORE_ERRORS = [
    'ValidationError',
    /UnauthorizedError/i,
    'Invalid CSRF token',
];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2VudHJ5RGVmYXVsdHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvc2VudHJ5RGVmYXVsdHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsTUFBTSxDQUFDLE1BQU0sNkJBQTZCLEdBQTJCO0lBQ25FLG9DQUFvQztJQUNwQyw4REFBOEQ7SUFDOUQsc0NBQXNDO0lBQ3RDLDZCQUE2QjtJQUM3QixnQkFBZ0I7SUFDaEIsZUFBZTtJQUNmLFlBQVk7SUFDWiwyQkFBMkI7SUFDM0IsV0FBVztDQUNaLENBQUM7QUFFRixNQUFNLENBQUMsTUFBTSx5QkFBeUIsR0FBYTtJQUNqRCxlQUFlO0lBQ2YsZUFBZTtJQUNmLHlCQUF5QjtJQUN6QixzQkFBc0I7SUFDdEIseUJBQXlCO0NBQzFCLENBQUM7QUFFRixNQUFNLENBQUMsTUFBTSwwQkFBMEIsR0FBMkI7SUFDaEUsaUJBQWlCO0lBQ2pCLG9CQUFvQjtJQUNwQixvQkFBb0I7Q0FDckIsQ0FBQyJ9